import ZipFirstInput from '../Input/ZipFirstInput';
import { YEAR } from 'lib/constants';

type Props = {
  provider: string;
};

export default function UtilityHeaderSection({ provider }: Props) {
  return (
    <div className={`relative bg-blue-500`}>
      <div className="relative px-2 py-8 mx-auto max-w-7xl sm:py-12 sm:px-6 lg:px-12">
        <div className="flex flex-col sm:flex-row items-center justify-between mx-8 md:mx-16">
          <div className="mb-8 sm:mb-0 sm:mr-8">
            <div className="flex justify-center md:justify-start">
              <div className="flex flex-col md:flex-row">
                <div className="flex flex-col justify-center">
                  <h3 className="text-md md:text-lg text-white text-center md:text-left md:pl-2">
                    UTILITIES AND OUTAGE INFORMATION {YEAR}
                  </h3>
                  <h1
                    className={`text-4xl  font-bold capitalize text-center md:text-left text-white  sm:tracking-tight  mt-2 pl-2 mb-2`}
                  >
                    {provider}
                  </h1>
                  <h3 className="text-lg text-white pl-2 w-full text-center md:text-left md:w-3/4 ">
                    Explore utility companies with EnergyPal. Get contact
                    details, outage information, and see rates effortlessly.
                  </h3>
                </div>
              </div>
            </div>{' '}
          </div>

          <div className="bg-white md:px-8 py-6 rounded-3xl w-full md:w-96 mx-auto text-center">
            <h3 className="text-xl font-semibold mb-4">
              Eliminate Outages
              <br />
              <span className="text-lg">With Solar and Battery Backup</span>
            </h3>

            <div className="px-6">
              <ZipFirstInput />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
